import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader } from "@/components/Layout";
import {
  Tabs, TabsContent, TabsList, TabsTrigger,
} from "@/components/ui/tabs";
import DailyView from "@/components/attendance/DailyView";
import MonthlyView from "@/components/attendance/MonthlyView";

export default function Attendance() {
  const { user } = useAuth();
  const [view, setView] = useState("daily");

  return (
    <div className="min-h-screen bg-white" data-testid="attendance-page">
      <PageHeader title="Attendance" subtitle="Daily logs & Monthly statistics" />

      <div className="px-4 sm:px-8 py-6">
        <Tabs value={view} onValueChange={setView}>
          <TabsList className="bg-transparent border-b border-slate-200 rounded-none w-full justify-start h-auto p-0 mb-5">
            <TabsTrigger value="daily" className="rounded-none border-b-2 border-transparent data-[state=active]:border-[#0a2540] data-[state=active]:shadow-none pb-2 px-4" data-testid="tab-daily">Daily</TabsTrigger>
            <TabsTrigger value="monthly" className="rounded-none border-b-2 border-transparent data-[state=active]:border-[#0a2540] data-[state=active]:shadow-none pb-2 px-4" data-testid="tab-monthly">Monthly</TabsTrigger>
          </TabsList>
          <TabsContent value="daily"><DailyView currentUser={user} /></TabsContent>
          <TabsContent value="monthly"><MonthlyView currentUser={user} /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
